import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from 'react'

type GalleryPreloadProviderType = {
  preload: boolean
  startPreload: () => void
}

const DEFAULT_GALLERY_PRELOAD_PROVIDER: GalleryPreloadProviderType = {
  preload: false,
  startPreload: () => null,
}

const GalleryPreloadContext = createContext<GalleryPreloadProviderType>(DEFAULT_GALLERY_PRELOAD_PROVIDER)

type Props = {
  children: ReactNode
}

export const GalleryPreloadProvider = ({ children }: Props) => {
  const [preload, setPreload] = useState(false)

  const startPreload = useCallback(() => setPreload(true), [])
  const value = useMemo(() => ({ preload, startPreload }), [preload, startPreload])

  return <GalleryPreloadContext.Provider value={value}>{children}</GalleryPreloadContext.Provider>
}

export const useGalleryPreload = (): GalleryPreloadProviderType => useContext(GalleryPreloadContext)
